import React, {useMemo} from 'react';
import {ICON_FLOAT_CHATTY, ICON_FLOAT_UPLOAD} from '@functions/const/floatWidgetButton';
import {iconArray} from '@assets/const/iconArray';
import IconFitContainer from '@assets/components/IconFitContainer';
import PropTypes from 'prop-types';
import {sizeMapping} from '@assets/const/popupSize';

const buttonDefaultSettings = {
  iconSize: '12px'
};

export default function LauncherIcon({settings, isCustomSize, iconWidth, iconHeight, iconColor}) {
  const {floatBtnSize, urlLogo, icon} = settings;
  const isUploadIcon = useMemo(() => icon === ICON_FLOAT_UPLOAD, [icon]);
  const isChattyIcon = useMemo(() => icon === ICON_FLOAT_CHATTY, [icon]);

  const iconSize = useMemo(() => {
    if (isCustomSize) return sizeMapping[floatBtnSize] || buttonDefaultSettings.iconSize;
    switch (icon) {
      case ICON_FLOAT_UPLOAD:
        return '25px';
      case ICON_FLOAT_CHATTY:
        return '16px';
      default:
        return buttonDefaultSettings.iconSize;
    }
  }, [icon, floatBtnSize, isCustomSize]);

  const iconPadding = isCustomSize ? '6px' : '4px';
  const IconArray = [...iconArray, {key: ICON_FLOAT_UPLOAD, Icon: FloatIconUpload}];
  const Icon = IconArray.find(item => item.key === icon)?.Icon || (() => null);

  if (isUploadIcon) return <Icon color={iconColor} urlLogo={urlLogo} size={iconSize} />;

  return (
    <IconFitContainer
      parentStyle={{width: iconWidth, height: iconHeight, padding: iconPadding}}
      childStyle={
        !isChattyIcon ? {padding: '4px', backgroundColor: '#FFFFFF', borderRadius: '50%'} : {}
      }
      className={[
        isCustomSize && 'Avada-Faq_FitIcon-Container__zoomIn',
        isChattyIcon && 'chatty-icon'
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <Icon color={iconColor} urlLogo={urlLogo} size={iconSize} />
    </IconFitContainer>
  );
}

const FloatIconUpload = ({size, urlLogo}) => {
  return (
    <img
      loading={'lazy'}
      alt="Chatty icon"
      src={urlLogo}
      width={size}
      style={{width: size}}
      className="Avada-Launcher__Button--icon-upload"
    />
  );
};

FloatIconUpload.propTypes = {
  size: PropTypes.string,
  urlLogo: PropTypes.string
};

LauncherIcon.propTypes = {
  settings: PropTypes.object,
  isCustomSize: PropTypes.bool,
  iconWidth: PropTypes.string,
  iconHeight: PropTypes.string,
  iconColor: PropTypes.string
};
